export enum RoutePathEnum {
  MAIN = '',
  LIST = 'list',
  UPLOADS = 'uploads',
}
